module.exports = __webpack_public_path__ + "media/evolve/assets/icons/fontawesome/solid/chevron-down-b79f7d72a4a12acad952bdef728d3053.svg";